import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
    databaseURL: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
    projectId: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}`,
    storageBucket: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}.appspot.com`,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
};

const firebase = initializeApp(firebaseConfig);

window.firebase = firebase;

export const fb = firebase;

export const db = getFirestore(firebase);
